export type Status = {
  id?: string;
  // TODO: Date 型で揃えるなら API から来た型と、TS 内で扱う型を分ける
  display_date: string;
  permission_id?: string;
};
export type IStatuses = {
    [key: string]: Status[]
}

export class Statuses {
  private data: IStatuses;

  constructor(data: IStatuses) {
    this.data = data;
  }

  getStatuses(): IStatuses {
    return this.data;
  }

  getTargetPlanStatus(docKind: string): Status[]|undefined {
    return this?.data[docKind];
  }
}
